import { money, selection, validQuantity, bundleMode } from './bb-commerce.js';
function measure(name, data) { try { window.BBAnalytics?.track(name, data); } catch {} }
const root = window.Shopify?.routes?.root || '/';
const text = (key, fallback) => window.bbText?.[key] || fallback;
const improved = (key, fallback) => window.bbText?.improve?.[key] || fallback;
const cartUrl = root + 'cart';
const activity = window.bbCartActivity ||= { pending: 0 };
function beginCart() { activity.pending += 1; activity.returnTo = null; }
function endCart() { activity.pending = Math.max(0, activity.pending - 1); document.dispatchEvent(new Event('bb:cart-settled')); }

async function request(path, body) {
  const response = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(typeof data.description === 'string' ? data.description : text('error', 'We couldn’t update your bag. Please check availability and try again.'));
    error.serverResponse = true; error.status = response.status; throw error;
  }
  return data;
}
function publishCart(cart) {
  document.querySelectorAll('[data-bb-count]').forEach(el => el.textContent = cart.item_count);
  if (Array.isArray(cart.items) && typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'boo-and-breeze', cartData: cart });
}
function initializeBuybox(box) {
  if (box.dataset.bound) return;
  box.dataset.bound = 'true';
  const product = JSON.parse(box.querySelector('[data-bb-product]').textContent);
  const add = box.querySelector('[data-bb-add]'), status = box.querySelector('[data-bb-status]');
  const radios = [...box.querySelectorAll('input[type=radio]')], sticky = document.querySelector('[data-bb-sticky]');
  let busy = false, addSource = 'primary';
  const selected = () => radios.find(input => input.checked);
  const current = () => selected() ? selection(product, selected().value) : null;
  const requested = bundleMode(location.search);
  if (requested) {
    radios.forEach(input => input.checked = input.value === requested);
    if (['pair', 'companion-pair'].includes(requested)) box.querySelector('[data-bb-other-sets]')?.setAttribute('open', '');
    if (!selection(product, requested)) status.textContent = improved('bundle_unavailable', 'This set is unavailable. Please choose another available option.');
  }
  function update() {
    const choice = current(); add.disabled = busy || !choice;
    add.textContent = busy ? text('adding', 'Adding…') : choice ? `${text('add', 'Add to bag')} · ${money(choice.total)}` : text('sold_out', 'Sold out');
    const pieces = choice?.items.reduce((sum, item) => sum + item.quantity, 0) || 1;
    box.querySelector('[data-bb-shipping]').textContent = pieces >= 2 ? text('free_shipping', 'Free standard shipping in our delivery area') : text('shipping', '$2.99 standard shipping · Contiguous U.S. & D.C.');
    if (sticky) {
      sticky.querySelector('[data-bb-sticky-label]').textContent = selected()?.dataset.bbLabel || product.title;
      sticky.querySelector('[data-bb-sticky-total]').textContent = choice ? money(choice.total) : text('sold_out', 'Sold out');
      const button = sticky.querySelector('[data-bb-sticky-add]'); button.disabled = busy || !choice;
      button.textContent = busy ? text('adding', 'Adding…') : improved('add_selected', 'Add to bag');
    }
  }
  radios.forEach(input => input.addEventListener('change', () => {
    status.textContent = ''; update();
    const chosenProduct = input.value === 'companion-pair' ? product.companion : product;
    measure('bundle_select', {bundle_mode:input.value,component:'buybox',variant_id:chosenProduct?.id || 0,product_id:chosenProduct?.productId || 0,value:(current()?.total || 0)/100,currency:'USD'});
  }));
  function restore() {
    busy = false; box.removeAttribute('aria-busy');
    radios.forEach(input => {
      if (input.dataset.wasDisabled !== undefined) input.disabled = input.dataset.wasDisabled === 'true';
    });
    update();
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted) { restore(); status.textContent = ''; }
  });
  add.addEventListener('click', async () => {
    const choice = current(); if (busy || !choice) return;
    const measurement = {component:addSource,variant_id:choice.items[0].id,product_id:(selected()?.value==='companion-pair'?product.companion.productId:product.productId)||0,bundle_mode:selected()?.value,value:choice.total/100,currency:'USD',quantity:choice.items.reduce((n,item)=>n+item.quantity,0)};
    addSource = 'primary'; measure('add_attempt',measurement);
    beginCart(); busy = true; status.textContent = ''; box.setAttribute('aria-busy', 'true');
    radios.forEach(input => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; }); update();
    try {
      await request('cart/add.js', { items: choice.items });
      measure('add_result',{...measurement,result:'success'});
      try { sessionStorage.setItem('bb-tracking-reminder-pending', '1'); } catch { /* Cart navigation remains available without storage. */ }
      status.textContent = text('added', 'Added to your bag.'); activity.returnTo = cartUrl; if (document.documentElement.dataset.bbLocalePending !== 'true') window.location.assign(cartUrl);
    } catch (error) {
      measure('add_result',{...measurement,result:error.serverResponse?'rejected':'uncertain',error_code:error.serverResponse?'http_error':'network',http_status:error.status || 0});
      status.textContent = error.serverResponse ? error.message : text('network_add', 'Connection interrupted. Check your bag before trying again—your item may already have been added.');
      box.querySelector('[data-bb-cart-after]').hidden = false;
      if (error.serverResponse) restore();
      // An interrupted response can still mean the order items were added.
      // Keep add controls locked until the visitor has checked the cart.
      else {
        activity.returnTo = cartUrl;
        box.removeAttribute('aria-busy');
        add.textContent = improved('check_bag', 'Check your bag');
        if (sticky) sticky.querySelector('[data-bb-sticky-add]').textContent = add.textContent;
      }
    } finally { endCart(); }
  });
  if (sticky && 'IntersectionObserver' in window) {
    sticky.querySelector('[data-bb-sticky-add]').addEventListener('click', () => { addSource = 'sticky'; add.click(); });
    const observer = new IntersectionObserver(entries => {
      const visible = !entries[0].isIntersecting; sticky.hidden = !visible;
      document.body.classList.toggle('bb-sticky-visible', visible);
    }); observer.observe(add);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(box)) { observer.disconnect(); document.body.classList.remove('bb-sticky-visible'); }
    });
  }
  update();
}
function initializeGallery(gallery) {
  if (gallery.dataset.bound) return; gallery.dataset.bound = 'true';
  const main = gallery.querySelector('[data-bb-main-image]') || gallery.querySelector('.bb-main-photo'); if (!main) return;
  gallery.querySelectorAll('[data-bb-thumb]').forEach(button => button.addEventListener('click', () => {
    measure('image_select',{component:'gallery',position:[...gallery.querySelectorAll('[data-bb-thumb]')].indexOf(button)+1});
    main.src = button.dataset.src;
    if (button.dataset.srcset) main.srcset = button.dataset.srcset; else main.removeAttribute('srcset');
    main.alt = button.dataset.alt || '';
    gallery.querySelectorAll('[data-bb-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
  }));
}
function initializeCart(cart) {
  if (cart.dataset.bound) return; cart.dataset.bound = 'true';
  let busy = false; const sectionId = cart.dataset.bbSectionId;
  const sectionPayload = () => sectionId ? { sections: [sectionId], sections_url: cartUrl } : {};
  function captureFocus() {
    const active = document.activeElement;
    return { key: active?.closest('[data-bb-line]')?.dataset.key, kind: active?.hasAttribute('data-bb-quantity') ? 'quantity' : active?.hasAttribute('data-bb-remove') ? 'remove' : active?.dataset.bbChange, scroll: window.scrollY };
  }
  function setBusy(value) {
    busy = value; cart.setAttribute('aria-busy', String(value));
    cart.querySelectorAll('button,input').forEach(el => {
      if (value) { el.dataset.bbOriginalDisabled = String(el.disabled); el.disabled = true; }
      else el.disabled = el.dataset.bbOriginalDisabled === 'true';
    });
  }
  async function replaceCart(data, focus, message = '') {
    let html = data?.sections?.[sectionId];
    if (!html) {
      const response = await fetch(cartUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Cart refresh failed'); html = await response.text();
    }
    const page = new DOMParser().parseFromString(html, 'text/html'), next = page.querySelector('[data-bb-cart]');
    if (!next) throw new Error('Cart section missing');
    let renderedCart;
    try { renderedCart = JSON.parse(next.querySelector('[data-bb-cart-data]')?.textContent); } catch {}
    cart.replaceWith(next); initializeCart(next);
    publishCart(renderedCart || { item_count: Number(next.dataset.bbCartCount) || 0 });
    const status = next.querySelector('[data-bb-cart-status]');
    if (status) status.textContent = message || improved('cart_updated', 'Your bag has been updated.');
    const line = [...next.querySelectorAll('[data-bb-line]')].find(item => item.dataset.key === focus.key); let target;
    if (line) {
      if (focus.kind === 'quantity') target = line.querySelector('[data-bb-quantity]');
      else if (focus.kind === 'remove') target = line.querySelector('[data-bb-remove]');
      else target = [...line.querySelectorAll('[data-bb-change]')].find(button => button.dataset.bbChange === focus.kind);
    }
    target ||= status || next.querySelector('h1');
    if (target) { if (!target.matches('button,input,a')) target.tabIndex = -1; target.focus({ preventScroll: true }); }
    window.scrollTo({ top: focus.scroll, behavior: 'instant' });
  }
  function uncertain(message) {
    cart.setAttribute('aria-busy', 'false');
    const status = cart.querySelector('[data-bb-cart-status]'); if (!status) return;
    status.replaceChildren(document.createTextNode(message + ' '));
    const link = document.createElement('a'); link.href = cartUrl; link.textContent = improved('reload_bag', 'Reload your bag'); link.className = 'bb-cart-after';
    status.append(link); status.tabIndex = -1; status.focus({ preventScroll: true });
  }
  async function mutate(path, body, measurement = {}) {
    if (busy) return; beginCart(); const focus = captureFocus(); setBusy(true);
    const status = cart.querySelector('[data-bb-cart-status]'); if (status) status.textContent = text('updating', 'Updating your bag…');
    measure('cart_change',{...measurement,quantity:body.quantity ?? 1});
    let changed = false;
    try {
      const data = await request(path, { ...body, ...sectionPayload() }); changed = true; await replaceCart(data, focus);
      measure('cart_result',{...measurement,quantity:body.quantity ?? 1,result:'success'});
    } catch (error) {
      measure('cart_result',{...measurement,result:changed?'render_error':error.serverResponse?'rejected':'uncertain',error_code:error.serverResponse?'http_error':'network',http_status:error.status || 0});
      if (error.serverResponse) { try { await replaceCart(null, focus, error.message); return; } catch {} }
      if (changed || !error.serverResponse) uncertain(text('network_cart', 'Connection interrupted. Reload your bag to confirm the latest quantity before trying again.'));
      else { setBusy(false); if (status) status.textContent = error.message; }
    } finally { endCart(); }
  }
  function change(line, raw) {
    try { const quantity = validQuantity(raw); mutate('cart/change.js', { id: line.dataset.key, quantity }, {component:'cart',action:quantity===0?'remove':'quantity',previous_quantity:Number(line.querySelector('[data-bb-quantity]').defaultValue ?? line.querySelector('[data-bb-quantity]').value),variant_id:line.dataset.key.split(':')[0]}); }
    catch (error) { const status = cart.querySelector('[data-bb-cart-status]'); if (status) status.textContent = improved('quantity_error', error.message); }
  }
  cart.querySelectorAll('[data-bb-line]').forEach(line => {
    const input = line.querySelector('[data-bb-quantity]');
    line.querySelectorAll('[data-bb-change]').forEach(button => button.addEventListener('click', () => change(line, Math.max(0, Number(input.value) + Number(button.dataset.bbChange)))));
    line.querySelector('[data-bb-remove]')?.addEventListener('click', () => change(line, 0)); input.addEventListener('change', () => change(line, input.value));
  });
  cart.querySelector('[data-bb-upsell-form]')?.addEventListener('submit', event => {
    event.preventDefault(); const form = event.currentTarget;
    if (!form.querySelector('[data-bb-upsell-add]').disabled) mutate('cart/add.js', { items: [{ id: Number(form.elements.id.value), quantity: 1 }] },{component:'cart-upsell',action:'add',variant_id:form.elements.id.value});
  });
}
function initialize(scope = document) {
  scope.querySelectorAll('[data-bb-buy]').forEach(initializeBuybox);
  scope.querySelectorAll('[data-bb-gallery]').forEach(initializeGallery);
  scope.querySelectorAll('[data-bb-cart]').forEach(initializeCart);
}
initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.querySelectorAll('.bb-mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.bb-mobile-menu[open]').forEach(menu => { menu.removeAttribute('open'); menu.querySelector('summary').focus(); });
});
